var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("my-" + _vm.smallSpace + " my-md-" + _vm.space)})}
var staticRenderFns = []

export { render, staticRenderFns }